/* ═══════════════════════════════════════════════════
   TrackLab v2 — Detail Mode Toggle
   ═══════════════════════════════════════════════════ */

(function () {
  'use strict';

  var STORAGE_KEY = 'tl_detail';
  // Stored/user-facing modes; CSS keeps the legacy class names detail-core/standard/deep.
  var MODES = ['less', 'more', 'full'];
  var CSS_CLASS = { less: 'core', more: 'standard', full: 'deep' };
  var LEGACY = { core: 'less', standard: 'more', deep: 'full' };
  var DEFAULT_MODE = 'less';

  function normalise(val) {
    if (MODES.indexOf(val) !== -1) return val;
    if (Object.prototype.hasOwnProperty.call(LEGACY, val)) return LEGACY[val];
    return null;
  }

  TL.detail = {};

  /**
   * Read the saved detail mode from localStorage.
   * Returns 'less', 'more', or 'full' ('less' for first-time visitors on
   * every viewport). Old stored core/standard/deep are migrated and rewritten.
   */
  TL.detail.get = function () {
    try {
      var val = localStorage.getItem(STORAGE_KEY);
      var mode = normalise(val);
      if (!mode) return DEFAULT_MODE;
      if (mode !== val) localStorage.setItem(STORAGE_KEY, mode);
      return mode;
    } catch (e) {
      return DEFAULT_MODE;
    }
  };

  function paintToggle(mode) {
    var btns = document.querySelectorAll('.detail-toggle .dt-btn');
    for (var j = 0; j < btns.length; j++) {
      var on = btns[j].dataset.mode === mode;
      btns[j].classList.toggle('active', on);
      btns[j].setAttribute('aria-checked', on ? 'true' : 'false');
      btns[j].setAttribute('tabindex', on ? '0' : '-1');
    }
  }

  function applyClass(mode) {
    // Update both <html> and <body> for consistency
    var targets = [document.documentElement, document.body];
    for (var t = 0; t < targets.length; t++) {
      for (var i = 0; i < MODES.length; i++) {
        targets[t].classList.remove('detail-' + CSS_CLASS[MODES[i]]);
      }
      targets[t].classList.add('detail-' + CSS_CLASS[mode]);
    }
  }

  /**
   * Apply a detail mode: update html/body class, localStorage, and toggle UI.
   * Accepts less/more/full (legacy core/standard/deep are mapped).
   */
  TL.detail.set = function (mode) {
    mode = normalise(mode) || DEFAULT_MODE;
    applyClass(mode);
    try { localStorage.setItem(STORAGE_KEY, mode); } catch (e) { /* quota */ }
    paintToggle(mode);
  };

  var _wired = typeof WeakSet === 'function' ? new WeakSet() : null;

  function wireToggle(group) {
    if (_wired) { if (_wired.has(group)) return; _wired.add(group); }
    var btns = group.querySelectorAll('.dt-btn');
    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function () {
        TL.detail.set(this.dataset.mode);
      });
    }
    // Left/Right (and Up/Down) move between the options, like a radio group.
    group.addEventListener('keydown', function (e) {
      var dir = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1
        : ((e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0);
      if (!dir) return;
      var list = group.querySelectorAll('.dt-btn');
      var idx = -1;
      for (var k = 0; k < list.length; k++) { if (list[k] === document.activeElement) idx = k; }
      if (idx === -1) idx = MODES.indexOf(TL.detail.get());
      var next = list[(idx + dir + list.length) % list.length];
      e.preventDefault();
      TL.detail.set(next.dataset.mode);
      next.focus();
    });
  }

  /**
   * Initialize: wire up toggle buttons.
   * The html class is already set by the inline script in v2_base.html,
   * so this only needs to sync the body class and activate the matching button.
   */
  /**
   * Mode from a ?detail= query string (less|more|full, legacy core|standard|deep),
   * or null if absent/invalid.
   */
  TL.detail.fromUrl = function (search) {
    if (search == null) search = window.location.search;
    var m = /[?&]detail=([^&#]*)/.exec(search);
    return m ? normalise(m[1]) : null;
  };

  TL.detail.init = function () {
    // A valid ?detail= param is authoritative and is persisted.
    var fromUrl = TL.detail.fromUrl();
    if (fromUrl) {
      try { localStorage.setItem(STORAGE_KEY, fromUrl); } catch (e) { /* quota */ }
    }
    var current = fromUrl || TL.detail.get();
    applyClass(current);
    paintToggle(current);
    var groups = document.querySelectorAll('.detail-toggle');
    for (var i = 0; i < groups.length; i++) wireToggle(groups[i]);
  };

  /**
   * Single toggle on pages with expandable race cards: move the one
   * #detailToggle node to the top of `container` (an open card's
   * .race-runners), or back to #detailToggleSlot with unmount().
   */
  TL.detail.mount = function (container) {
    var node = document.getElementById('detailToggle');
    if (!node || !container) return;
    container.insertBefore(node, container.firstChild);
  };

  TL.detail.unmount = function () {
    var node = document.getElementById('detailToggle');
    var slot = document.getElementById('detailToggleSlot');
    if (!node || !slot || node.parentNode === slot) return;
    slot.appendChild(node);
  };

  /* "Hide explainers" preference (set by the landing "Experienced punter?" link). */
  var EXPLAINERS_KEY = 'tl_hide_explainers';

  TL.explainers = {
    hidden: function () {
      try { return localStorage.getItem(EXPLAINERS_KEY) === '1'; } catch (e) { return false; }
    },
    set: function (hide) {
      try {
        if (hide) localStorage.setItem(EXPLAINERS_KEY, '1');
        else localStorage.removeItem(EXPLAINERS_KEY);
      } catch (e) { /* quota */ }
      document.documentElement.classList.toggle('hide-explainers', !!hide);
      document.body.classList.toggle('hide-explainers', !!hide);
    }
  };

  // Auto-init when DOM is ready (scripts load at bottom of body)
  TL.detail.init();
  if (TL.explainers.hidden()) TL.explainers.set(true);
})();
